<core-ui-modal
  [open]="open()"
  [title]="title()"
  [closeOnBackdrop]="false"
  [closeOnEsc]="false"
  [size]="'sm'"
>
  <p class="server-error-modal__body">{{ body() | translate }}</p>
  @if (errorDetails().length > 0) {
    <details class="server-error-modal__details" open>
      <summary class="server-error-modal__details-toggle">
        <span class="server-error-modal__details-show">Show backend error</span>
        <span class="server-error-modal__details-hide">Hide backend error</span>
        ({{ errorDetails().length }})
      </summary>
      <div class="server-error-modal__details-box">
        @for (detail of errorDetails(); track $index) {
          <div class="server-error-modal__details-entry">
            <span class="server-error-modal__details-type">{{ detail.type }}</span>
            <p class="server-error-modal__details-message">{{ detail.message }}</p>
            @if (detail.request) {
              <span class="server-error-modal__details-request">{{ detail.request }}</span>
            }
            @if (detail.trace) {
              <details class="server-error-modal__details-trace">
                <summary class="server-error-modal__details-toggle">
                  <span class="server-error-modal__details-show">Show trace</span>
                  <span class="server-error-modal__details-hide">Hide trace</span>
                </summary>
                <pre class="server-error-modal__details-pre">{{ detail.trace }}</pre>
              </details>
            }
          </div>
        }
      </div>
    </details>
  }
  @switch (phase()) {
    @case ('counting') {
      <div class="server-error-modal__status">
        <wpp-countdown-timer [secondsLeft]="secondsLeft()" [totalSeconds]="retryDelaySeconds" />
        <span class="server-error-modal__status-label">{{
          'wpp.component.server-error-modal.countdown-label' | translate
        }}</span>
      </div>
    }
    @case ('retrying') {
      <div class="server-error-modal__status">
        <wpp-piston-loader size="2.5rem" label="" />
        <span class="server-error-modal__status-label">{{
          'wpp.component.server-error-modal.retrying-label' | translate
        }}</span>
      </div>
    }
    @case ('failed') {
      <div class="server-error-modal__actions">
        <core-ui-button (buttonClick)="reloadPage()">{{
          'wpp.component.server-error-modal.reload-label' | translate
        }}</core-ui-button>
      </div>
    }
  }
</core-ui-modal>
